import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { formatTime } from '../../../utils/dateFunctions';
import { DEFAULT_TABLE_ROWS_PER_PAGE } from '../../../utils/formValidation/commonConstants';
import { AUDIT_EVENT_HISTORY_ERROR } from '../../../utils/formValidation/loadingErrorMessageConstants';
import { stableSort } from '../../../utils/sortFunctions';
import { uuid } from '../../../utils/stringUtils';
import ResultsTable from '../../table/ResultsTable';
import LoadingSpinner from '../../ui/LoadingSpinner';

import AuditLTCPTableRow from './AuditLTCPTableRow';

const headCells = [
    { id: 'from', numeric: false, label: 'From', sortable: false },
    { id: 'to', numeric: false, label: 'To', sortable: false },
    { id: 'user', numeric: false, label: 'Author User Id' },
    { id: 'date', numeric: false, label: 'Date Changed' },
    { id: 'formattedTime', numeric: false, label: 'Time Changed' }
];

const initialRowMetaData = {
    order: 'desc',
    orderBy: 'date',
    page: 0,
    rowsPerPage: DEFAULT_TABLE_ROWS_PER_PAGE
};

const AuditLTCPManagement = () => {
    // LOCAL STATE
    const [rows, setRows] = useState([]);
    const [rowMetaData, setRowMetaData] = useState(initialRowMetaData);
    const [loadingContentMessage, setLoadingContentMessage] = useState('');

    // STORE STATE
    const participantAuditData = useSelector(
        (state) => state.entities.participantService.participantAuditEventSearchData
    );

    // USEEFFECTS
    useEffect(() => {
        if (participantAuditData?.length < 1) {
            setLoadingContentMessage(AUDIT_EVENT_HISTORY_ERROR);
            return;
        }
        setRows(
            participantAuditData.map((el) => ({
                ...el,
                id: uuid(),
                user: el.user || 'Polaris System',
                formattedTime: formatTime(el.date)
            }))
        );
    }, [participantAuditData]);

    // HELPER fNS
    const createRows = () =>
        stableSort(rows, rowMetaData.orderBy, rowMetaData.order).map((el) => (
            <AuditLTCPTableRow key={el.id} row={el} />
        ));

    // RENDER
    return rows.length < 1 ? (
        <LoadingSpinner content={loadingContentMessage} />
    ) : (
        <ResultsTable
            defaultOrderBy={rowMetaData.orderBy}
            sortOrder={rowMetaData.order}
            headCells={headCells}
            passRowMetaDataUp={setRowMetaData}
            tableRows={createRows()}
            totalResults={rows.length}
        />
    );
};

export default AuditLTCPManagement;
